(ns app.front.view.workspace.additional-properties
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.property.model :as property-model]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.create-application.gis-search :as gis-search]
            [app.front.view.property.attribute :as property-attribute]
            [app.front.view.workspace.property-subs :as property-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::loading?
  :<- [::property-subs/loading-point?]
  :<- [::gis-search/pending?]
  (fn [[point-loading? search-loading?] _]
    (or point-loading? search-loading?)))

(defn- table-list-with-remove [{:keys [tr target-id cols items]}]
  [ui-table/modern-responsive-table
   {:cols  (conj cols
                 (when (<sub [::process/signal-permitted?
                              target-id
                              [:process.signal/remove-property]])
                   [""
                    (fn [property]
                      (let [remove-signal [:process.signal/remove-property
                                           {:property-id (:db/id property)}]]
                        (when (<sub [::process/signal-permitted? target-id remove-signal])
                          [ui/modal-confirmation-button
                           {:tr                tr
                            :id                "delete-property"
                            :modal-title       (tr [:property/delete])
                            :trigger-icon-opts {:icon        i/trash
                                                :description (tr [:property/delete])
                                                :class-name  "cursor-pointer"}
                            :on-yes-click      #(>evt [::process/signal
                                                       target-id
                                                       remove-signal
                                                       {:notify {:success :property/deleted}}])}
                           (tr [:property/delete-confirm])])))
                    {:width "30px"}]))
    :tr    tr
    :items items}])


(defn get-properties [workspace type]
  (->> (:workspace/properties workspace)
       (filter #(and (not= (:workspace/primary-property workspace) %)
                     (= type (:property/type %))))
       (sort-by :property/id)))


(defn properties-list [{:keys [target-id workspace tr]}]
  [table-list-with-remove
   (let [properties       (get-properties workspace :property.type/property)
         show-attributes? (some #(-> % :property/legacy-attributes seq) properties)]
     (util/mmap {:items properties
                 :cols  [[:workspace/address
                          property-model/full-address
                          {:width "30%"
                           :flex  1}]
                         [(tr [:property/id])
                          :property/id
                          {:width "180px"
                           :flex  "none"}]
                         [(tr [:property/legal])
                          :property/legal
                          {}]
                         [(tr [:property/zoning])
                          :property/zoning
                          {:width "70px"
                           :flex  "none"}]
                         (when show-attributes? [nil
                                                 property-attribute/attribute-tags-from-property
                                                 {:width "20%"
                                                  :flex  1}])]}
                target-id
                tr))])

(defn roads-list [{:keys [target-id workspace tr]}]
  (when-let [items (seq (get-properties workspace :property.type/road))]
    [:<>
     [:h4.my-4 (tr [:property.type/roads])]
     [table-list-with-remove
      (util/mmap {:items items
                  :cols  [[:workspace/address
                           property-model/full-address
                           {:width "30%"
                            :flex  1}]
                          [:property/description
                           (fn [property]
                             (if (:property/from-st property)
                               (tr [:property/from-to]
                                   [(:property/from-st property)
                                    (:property/to-st property)])
                               "-"))]]}
                 target-id
                 tr)]]))


(defn additionals-section [{:keys [workspace target-id tr]}]
  (when (-> workspace :workspace/properties rest seq)
    [section/section
     :additional-properties
     (util/mmap {:class          "mt-4"
                 :heading-button (when (<sub [::process/signal-permitted?
                                              target-id
                                              [:process.signal/add-additional-property]])
                                   (cc/button
                                     {:on-click         #(>evt [::property-subs/set-add-visible])
                                      :kind             :ghost
                                      :icon-description ""
                                      :icon             i/plus}
                                     (tr [:process.signal/add-additional-property])))}
                tr)
     (tr [:workspace/additional-properties])
     [properties-list (util/mmap target-id workspace tr)]
     [roads-list (util/mmap target-id workspace tr)]]))

(defn common-property-select [{:keys [tr target-id workspace ok-signal guide-i18n on-cancel
                                      group-gis-layers? layer-id-fn]}]
  (let [candidate                 (<sub [::property-subs/candidate])
        loading?                  (<sub [::loading?])
        valid-candidate-property? (-> candidate :property :property/id str/blank? not)
        municipality              (:workspace/municipality workspace)
        subdivision               (:municipality/subdivision municipality)
        create-property-visible?  (and (<sub [::property-subs/change-property-visible?])
                                       (empty? candidate)
                                       (<sub [::process/signal-permitted?
                                              target-id
                                              [:process.signal/create-primary-property]]))]
    [:div.bg-ui-white.p-4
     [:div.flex.flex-wrap
      [:div.w-1-2.pr-3
       (when loading?
         (cc/inline-loading {:description (tr [:wizard/searching])}))
       (cond
         (and candidate
              (not valid-candidate-property?))
         [create-v2/missing-property-data tr]

         candidate
         [:div {:class (when (not loading?) "mt-8")}
          [create-v2/selected-location tr
           (assoc (property-model/gis-property->wizard-property candidate)
                  :subdivision subdivision)
           (and (ptc-model/permit-types-with-row-layers (:workspace/permit-type workspace))
                (ff/enabled? :feature-flag.id/create-workspace-with-manual-location))]]

         (not loading?)
         [:span.font-bold
          (str/join ". "
                    (concat
                      [(tr [guide-i18n])]
                      (when create-property-visible?
                        [(tr [:workspace/create-property-help])])))]

         :else nil)]
      [:div.flex.w-1-2.mb-6
       [gis-search/address-search
        (util/mmap {:domain-group-id       (-> workspace :domain/authority-group :entity/parent :group/id)
                    :municipalities        [(-> municipality :municipality/number)]
                    :subdivision           subdivision
                    :on-select-address     #(>evt [::property-subs/set-candidate-from-address-search %])
                    :on-select-location    #(>evt [::property-subs/set-candidate-from-address-search %])
                    :clear-fn              #(>evt [::property-subs/clear-candidate])
                    :group-gis-layers?     group-gis-layers?
                    :layer-id-fn           layer-id-fn
                    :result-list-min-width "700px"
                    :show-existing?        false}
                   tr)]]]
     (when (<sub [::property-subs/already-added? target-id])
       [:div.p-4.font-bold (tr [:property/already-added])])
     [:div.flex.justify-end.pt-4
      (if (<sub [::property-subs/in-progress?])
        (cc/loading-spinner {:with-overlay false
                             :small        true})
        [:<>
         [ui-action-buttons/action-buttons
          {:buttons [{:on-click on-cancel
                      :text     (tr [:cancel])}
                     (when create-property-visible?
                       {:on-click #(>evt [::property-subs/open-create-property-modal])
                        :text     (tr [:workspace/create-property])})
                     {:disabled? (not (<sub [::property-subs/candidate-valid? target-id]))
                      :icon      i/building
                      :on-click  #(>evt [::property-subs/do-add-property ok-signal target-id])
                      :text      (tr [ok-signal])}]}]
         [ui/confirm-modal
          {:id           "create-new-property-modal"
           :open?        (<sub [::property-subs/create-property-modal-open?])
           :tr           tr
           :modal-title  (tr [:workspace/create-property-confirmation])
           :on-close     #(>evt [::property-subs/close-create-property-modal])
           :on-yes-click #(>evt [::property-subs/create-property target-id])}
          (when (<sub [::property-subs/property-manager?])
            [:div.mt-2
             (cc/checkbox
               {:id         "redirect-to-property-view-checkbox"
                :label-text (tr [:workspace/create-property-redirect])
                :checked    (boolean (<sub [::property-subs/redirect-to-property-view?]))
                :on-change  #(>evt [::property-subs/toggle-property-view-redirect])})])]])]]))


(defn add-widget [props]
  (when (<sub [::property-subs/add-visible?])
    [common-property-select (merge props {:ok-signal  :process.signal/add-additional-property
                                          :guide-i18n :workspace/add-property-help})]))


(defn change-property-widget [props]
  (when (<sub [::property-subs/change-property-visible?])
    [common-property-select (merge props {:group-gis-layers? (ff/enabled?
                                                               :feature-flag.id/public-works-location-enhancements)
                                          :guide-i18n        :workspace/change-property-help
                                          :layer-id-fn       ::create-v2/layer-id-order
                                          :ok-signal         :process.signal/change-primary-property})]))
